(() => {
  'use strict';
  if (window.lcmTopbarNavigationLoaded) return;
  window.lcmTopbarNavigationLoaded = true;
  const close = (except) => document.querySelectorAll('.lcm-topbar__dropdown[open]').forEach(d => { if (d !== except) d.open = false; });
  document.addEventListener('click', event => {
    const d = event.target.closest('.lcm-topbar__dropdown');
    close(d);
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const d = event.target.closest('.lcm-topbar__dropdown[open]');
    if (d) { event.preventDefault(); d.open = false; d.querySelector('summary').focus(); }
  });
  document.addEventListener('focusin', event => close(event.target.closest('.lcm-topbar__dropdown')));
  window.addEventListener('resize', () => { if (window.innerWidth < 990) close(); });
})();
